






















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import dialogComp from "../index.vue";
import { Button } from "mint-ui";
import appointDialog from '@/components/dialog/submit/index'
import { share } from "@/utils/hybird";
import shareDialog from '@/components/dialog/share/index'
import { goUrl } from "@/utils/hybird"


@Component<VBANNER>({
  components: {
    dialogComp,
    "mt-button": Button,
  },
})
export default class VBANNER extends Vue {
  @Prop({default:''})
  public uname?:string;
  public questionIndex:number = 0;
  public questionIds:any = [];
  public questionContent:string = '';
  public audioSrc:string = '';
  public questionResult = {
      'A1-B2,D1-B2,D1-D2':{
          title:'<p><span class="arr-lf"></span><a>视觉之旅</a></p>将带给你最好的体验<br/><a>三亚</a>是个不错的选择',
          content:'想不到你竟然是个不折不扣的“颜控”，看来风景如画的城市最能满足你对旅行的超高审美要求。',
          btm:'东风标致508L：有新潮的外观才配得上与你一起赏八方之美。',
          result:'https://picbed.qunarzz.com/f74c5ba7366191cdaffd662b3a51a291.jpg'
      },
      'A1-C2,B1-D2,C1-C2':{
          title:'<p><span class="arr-lf"></span><a>听觉之旅</a></p>将带给你最好的体验<br/><a>上海</a>是个不错的选择',
          content:'想不到原来你是个十足的“声控”，看来拥有音乐基因的城市最能满足你对旅行的高品质向往。',
          btm:'东风标致508L：有立体环绕的音乐才能伴你一路欢歌去旅行。',
          result:'https://picbed.qunarzz.com/436ca31d02f15ccc12b6dd5f5e0f6bd6.jpg'
      },
      'A1-A2,C1-A2,C1-D2':{
          title:'<p><span class="arr-lf"></span><a>触觉之旅</a></p>将带给你最好的体验<br/><a>广州</a>是个不错的选择',
          content:'想不到你居然是个有性的“兴趣玩家”，只有拥有丰富刺激娱乐项目的城市能满足你对旅行的惊喜期待。',
          btm:'东风标致508L：有科技驾控实力，才能让你尽情享受驾驶乐趣。',
          result:'https://picbed.qunarzz.com/1056ef2c3a785d5bf26ec4b67bdd34cd.jpg'
      },
      'B1-A2,D1-A2':{
          title:'<p><span class="arr-lf"></span><a>嗅觉之旅</a></p>将带给你最好的体验<br/><a>深圳</a>是个不错的选择',
          content:'想不到原来你是个敏锐的“嗅觉神探”，看来探究城市本色的旅行才能解锁你对城市的好奇。',
          btm:'东风标致508L：有全时净化的能力，才能在拥有安全感的前提下开启好奇之旅。',
          result:'https://picbed.qunarzz.com/5fd131d62a439519b1766c9732aa151c.jpg'
      },
      'B1-B2':{
          title:'<p><span class="arr-lf"></span><a>味觉之旅</a></p>将带给你最好的体验<br/><a>成都</a>是个不错的选择',
          content:'想不到你竟然是个地道的“吃货”，看来最具烟火气的美食城市才能带给你最大的旅行享受。',
          btm:'东风标致508L：有足够自信才能足够任性，只有自在的旅途才能追逐自由的味道。',
          result:'https://picbed.qunarzz.com/83e3bb518db6ece309a636279c339c57.jpg'
      },
      'A1-D2,B1-C2,C1-B2,D1-C2':{
          title:'<p><span class="arr-lf"></span><a>知觉之旅</a></p>将带给你最好的体验<br/><a>杭州</a>是个不错的选择',
          content:'想不到你居然是个感性的“生活体验家”，只有轻松自在的城市才能满足你对旅行放松身心的要求。',
          btm:'东风标致508L：有智能辅助能力，才能人车合一让驾驶旅途更加轻松。',
          result:'https://picbed.qunarzz.com/3fe9284cbe983cb0ea0f574f72f5ac55.jpg'
      },
  }
  

  public imgList:any[] = [{
    src:'https://picbed.qunarzz.com/76994510b76c4d32be52f00471877ed6.png',
    questionId:'A1',
    active:false
  },{
    src:'https://picbed.qunarzz.com/f51de07e05153aeb873f7c400bdd686b.png',
    questionId:'B1',
    active:false
  },{
    src:'https://picbed.qunarzz.com/e623e21340fa145fc12b44b23622f273.png',
    questionId:'C1',
    active:false
  },{
    src:'https://picbed.qunarzz.com/c5b9ccd052aeea60aa8619302c85199d.png',
    questionId:'D1',
    active:false
  }];
  public audioList:any[] = [{
    src:'https://picbed.qunarzz.com/b7f5ac7d184a8996f391989d2b271032.png',
    questionId:'A2',
    audio:'https://picbed.qunarzz.com/6a9ded7e0fca0bc63a449af5c891dde1.mp3',
    play:false,
    active:false
  },{
    src:'https://picbed.qunarzz.com/01d9cdfa5acfd47a690302b50aee879b.png',
    questionId:'B2',
    play:false,
    audio:'https://picbed.qunarzz.com/7f085e70cdaebf8b7a5acf32d58ad452.mp3',
    active:false
  },{
    src:'https://picbed.qunarzz.com/e5f69d9e65c31c1c5d15127a25307f6a.png',
    questionId:'C2',
    play:false,
    audio:'https://picbed.qunarzz.com/91702a98251c8280d9475090f58720cf.mp3',
    active:false
  },{
    src:'https://picbed.qunarzz.com/af1a4c986f94a47d2e919508973c67dc.png',
    questionId:'D2',
    play:false,
    audio:'https://picbed.qunarzz.com/b8455552b6dea6eb645a26df3839cf6c.mp3',
    active:false
  }];
  public resultImg = 'https://picbed.qunarzz.com/4fe833ba864e877db201efd3a17ab370.png'
  public show() {
    (this.$refs.dialog as any).show();
  }
  public close() {
    (this.$refs.dialog as any).close();
  }

  public playAudio(item:any,ind:any){
      this.audioList.forEach((item,index)=>{
          var audio = (this as any).$refs['audio'+index][0];
          if(ind==index){
            this.$set(item,'play',!item.play);
            if(item.play){
                audio.play();
            }else{
                audio.pause();
            }
          }else{
            this.$set(item,'play',false);
            audio.pause();
          }
      })
  }

  public shareFirend(){
    share(()=>{
        shareDialog();
    })
  }

  public get request(){
      return (this as any).$axios
  }
  
  public get watchQuestionIds(){
    if(this.questionContent){
        var questionIdStr = this.questionIds.join('-')
        var keys = Object.keys(this.questionResult)
        var result = keys.filter((key)=>{
            if(key.indexOf(questionIdStr)!=-1){
                return true
            }
        })
        return {
          title:(this as any).questionResult[result[0]].title,
          content:'<a>'+this.uname+'</a>'+','+(this as any).questionResult[result[0]].content+'<img src="https://picbed.qunarzz.com/83ec668e5c97ff06ff75aeaf9eeacd03.png" class="car" alt="">',
          result:(this as any).questionResult[result[0]].result,
          btm:(this as any).questionResult[result[0]].btm
        }
    }
  }

  public async commitAnswer(){
    var questionIds:any = [];
    this.imgList.forEach((item,index)=>{
        if(item.active){
          questionIds.push(item.questionId)
        }
    })
    this.audioList.forEach((item,index)=>{
        if(item.active){
          questionIds.push(item.questionId)
        }
    })
    if(questionIds.length==0){
        (this as any).$dialog.alert({
              message:'请先选择一个答案'
        });
        return;
    }
    this.questionIds = questionIds;
    this.questionContent = this.questionIds.join(',');
    let params = {
      content:questionIds.join(',')
    };
    const res = this.request.post('/peugeot/commitAnswer',params);
  }

  public goUrl(url:any,linkId:any){
        goUrl(url,linkId)
    }

  public goNext(){
    var bool = false;
    this.imgList.forEach((item,index)=>{
        if(item.active){
          bool = true;
        }
    })
    if(!bool){
        (this as any).$dialog.alert({
              message:'请先选择一个答案'
        });
        return;
    }
    this.questionIndex = 1;
  }

  public goResult(){
    var bool = false;
    this.audioList.forEach((item,index)=>{
        if(item.active){
          bool = true;
        }
    })
    if(!bool){
        (this as any).$dialog.alert({
              message:'请先选择一个答案'
        });
        return;
    }
    this.questionIndex = 2;
    this.commitAnswer();
  }

  public goAppoint(){
     appointDialog({
       uname:this.uname
     });
  }

  public selectImg(ind:number){
    this.imgList.forEach((item,index)=>{
        if(ind==index){
          this.$set(item,'active',!item.active)
        }else{
          this.$set(item,'active',false)
        }
    })
  }

  public selectImg2(ind:number){
    this.audioList.forEach((item,index)=>{
        if(ind==index){
          this.$set(item,'active',!item.active)
        }else{
          this.$set(item,'active',false)
        }
    })
    this.audioSrc = this.audioList[ind].audio;
  }
}
